import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-registro-item',
  templateUrl: './registro-item.component.html',
  styleUrls: ['./registro-item.component.scss']
})
export class RegistroItemComponent implements OnInit {


  editionMode: boolean;

  @HostBinding('class') class = 'col-6';

  @Input()
  registro: any;

  constructor() {
    this.editionMode = false;

  }

  ngOnInit(): void {
    console.log(this.registro);
  }


  togleEdition(){
      this.editionMode = !this.editionMode;
      this.class =this.editionMode ? 'col-12' : 'col-6';

  }
}
